<template>
	<el-dropdown @command="getSort" v-if="options.length !== 0">
		<span class="el-dropdown-link cursor">
			{{ title || '请选择' }}
			<span class="caret-wrapper">
				<i class="sort-caret ascending" :class="getUp"></i>
				<i class="sort-caret descending" :class="getDown"></i>
			</span>
		</span>
		<el-tooltip
			class="item"
			effect="dark"
			placement="top-start"
			width="200"
			trigger="hover"
			v-if="content"
		>
			<div slot="content" v-html="content"></div>
			<i class="el-icon-question"></i>
		</el-tooltip>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item v-for="(item, index) in options" :key="index" :command="item.value">{{
				item.label
			}}</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	<div v-else class="el-dropdown">
		<span class="el-dropdown-link">
			{{ title || '请选择' }}
			<el-tooltip
				class="item"
				effect="dark"
				placement="top-start"
				width="200"
				trigger="hover"
				v-if="content"
			>
				<div slot="content" v-html="content"></div>
				<i class="el-icon-question"></i>
			</el-tooltip>
		</span>
	</div>
</template>
<script>
export default {
	props: {
		options: {
			default: () => [],
		},
		value: [String, Number, Boolean],
		title: [String, Number, Function],
		content: [String, Number],
	},
	data() {
		return {
			selected: null,
		};
	},
	computed: {
		getUp() {
			return {
				up: this.options && this.selected === this.options[0].value,
			};
		},
		getDown() {
			return {
				down: this.options && this.selected === this.options[1].value,
			};
		},
	},
	watch: {
		value: {
			handler(val) {
				this.selected = val;
			},
			immediate: true,
		},
	},
	methods: {
		getSort: function (item) {
			this.selected = item;
			this.$emit('sortChanged', item);
		},
		reset: function () {
			this.selected = null;
		},
	},
};
</script>
<style lang="scss" scoped>
.caret-wrapper {
	display: inline-flex;
	flex-direction: column;
	align-items: center;
	height: 34px;
	width: 18px;
	vertical-align: middle;
	cursor: pointer;
	overflow: initial;
	position: relative;
	& .sort-caret {
		width: 0;
		height: 0;
		border: solid 5px transparent;
		position: absolute;
		left: 4px;
	}
	& .sort-caret.ascending {
		border-bottom-color: #c0c4cc;
		top: 5px;
	}
	& .sort-caret.descending {
		border-top-color: #c0c4cc;
		bottom: 7px;
	}
	& .sort-caret.ascending.up {
		border-bottom-color: #409eff;
	}
	& .sort-caret.descending.down {
		border-top-color: #409eff;
	}
}
.el-dropdown-link {
	font-size: 12px;
	color: #4a4a4a;
}
.cursor {
	cursor: pointer;
}
.el-icon-question {
	font-size: 12px;
}
</style>
